export default __webpack_public_path__ + "static/vanilla-glaze-c66e4b5ba7a75bf91efffd9a4d04e29f.png";